import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function MeuPerfil() {
  const { user, login } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [salvando, setSalvando] = useState(false);

  const trocar = async (e) => {
    e.preventDefault();
    if (novaSenha.length < 6) {
      return Swal.fire({ icon: 'warning', title: 'Senha curta', text: 'Use no mínimo 6 caracteres.', confirmButtonColor: '#2e9846' });
    }
    if (novaSenha !== confirma) {
      return Swal.fire({ icon: 'warning', title: 'Senhas diferentes', text: 'A confirmação não bate.', confirmButtonColor: '#2e9846' });
    }
    setSalvando(true);
    try {
      const { data } = await api.post('/auth/trocar-senha', { senha_atual: senhaAtual, senha: novaSenha });
      if (data?.token) login(data.token);
      Swal.fire({ icon: 'success', title: 'Senha atualizada', confirmButtonColor: '#2e9846' });
      setSenhaAtual(''); setNovaSenha(''); setConfirma('');
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha ao trocar', confirmButtonColor: '#2e9846' });
    } finally {
      setSalvando(false);
    }
  };

  return (
    <>
      <div className="page-header-cli">
        <h1 className="page-title-cli">
          <i className="bi bi-person-circle"></i>
          Meu Perfil
        </h1>
      </div>

      <div className="card-cli">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
          <div>
            <label className="label-cli">Nome</label>
            <div>{user?.nome || '—'}</div>
          </div>
          <div>
            <label className="label-cli">{user?.tipo === 'cliente' ? 'CPF/CNPJ' : 'Usuário'}</label>
            <div>{user?.username || '—'}</div>
          </div>
          <div>
            <label className="label-cli">Tipo de acesso</label>
            <div>
              <span className="tag-cli">
                {user?.tipo === 'cliente' ? 'Cliente' : (user?.perfil_nome || 'Admin')}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="card-cli">
        <h2 style={{ marginTop: 0, color: 'var(--verde-escuro)', fontSize: '1.05rem' }}>
          <i className="bi bi-key-fill" style={{ color: 'var(--laranja)', marginRight: 6 }}></i>
          Trocar minha senha
        </h2>
        <form onSubmit={trocar} style={{ maxWidth: 420 }}>
          <div style={{ marginBottom: 10 }}>
            <label className="label-cli">Senha atual</label>
            <input type="password" className="input-cli" value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label className="label-cli">Nova senha</label>
            <input type="password" className="input-cli" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} placeholder="mín. 6 caracteres" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="label-cli">Confirmar nova senha</label>
            <input type="password" className="input-cli" value={confirma} onChange={e => setConfirma(e.target.value)} />
          </div>
          <button type="submit" className="btn-verde-cli" disabled={salvando}>
            {salvando ? 'Salvando…' : 'Trocar senha'}
          </button>
        </form>
      </div>
    </>
  );
}
